import { FunctionComponent } from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'dibs-react-intl';
import { IMAGE_URL } from '../../constants';
import { getSrcSetString } from '../../../utils/srcStringHelpers';

import styles from './questionListTop.scss';

const copy = defineMessages({
    imageCaption: {
        id: 'questionsAnswers.imageCaption',
        defaultMessage: 'Interior by Jamie Bush + Co. | Photography by Stephen Johnson',
    },
});

export const QuestionListTop: FunctionComponent = () => {
    const intl = useIntl();
    return (
        <div className={styles.wrapper}>
            <div className={styles.textWrapper}>
                <div className={styles.header} data-tn="questions-answers">
                    <FormattedMessage
                        id="questionsAnswers.header"
                        defaultMessage="Questions & Answers"
                    />
                </div>
                <div className={styles.subHeader}>
                    <FormattedMessage
                        id="questionsAnswers.subHeader"
                        defaultMessage="Our trusted network of 1stDibs sellers answer common questions"
                    />
                </div>
            </div>
            <div className={styles.imageWrapper}>
                <img
                    className={styles.image}
                    src={IMAGE_URL}
                    alt={intl.formatMessage(copy.imageCaption)}
                    srcSet={getSrcSetString({
                        url: IMAGE_URL,
                        quality: 80,
                    })}
                />
            </div>
            <div className={styles.imageCaption}>{intl.formatMessage(copy.imageCaption)}</div>
        </div>
    );
};
